import React from 'react';
import { Modal, Input, Form, Select, Row, Col, Divider, Icon, Popover, Button } from 'antd';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../common/types/regularExpresionType';
import global from '../../../common/utility/global';
import dialog from "../../../common/utility/dialog";

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    valor: parseFloat(values.valor),
                    idCliente: values.idCliente === undefined ? 0 : values.idCliente.key,
                    idMoneda: values.idMoneda === undefined ? 0 : values.idMoneda.key,
                }

                if (form.credito !== null && form.credito !== undefined) {
                    const creditoIngresado = form.credito.trim();

                    const existeCredito = this.props.formValues.tipoCreditos.some(e => e.nombre === creditoIngresado);

                    if (existeCredito) {
                        dialog.warning("Tipo de crédito ya existe.");
                        return false;
                    }
                }

                this.props.onSave(form, this.props.form);


            }
        });
    }


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Línea de crédito" : "Modificar Línea de crédito"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>



                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Cliente">
                                {getFieldDecorator('idCliente', {
                                    initialValue: this.props.formValues.idCliente > 0 ?
                                        { key: this.props.formValues.idCliente } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Cliente"}
                                        optionFilterProp="children"
                                        disabled={this.props.formValues.id > 0 ? true : false}
                                    >
                                        {this.props.formValues.clientes.map(item => (
                                            <Option key={item.id} value={item.id} > {item.title} </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda > 0 ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map(item => (

                                            item.codigoSunat == "PEN" ?
                                                <Option key={item.id} value={item.id} >{item.nombre} </Option>
                                                : null

                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Línea de crédito">
                                {getFieldDecorator('valor', {
                                    initialValue: parseFloat(this.props.formValues.valor).toFixed(2),
                                    rules: [{
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato decimal incorrecto (0.00)"
                                    },
                                    {
                                        required: true,
                                        pattern: new RegExp(GREATER_THAN_ZERO),
                                        message: "Ingrese un valor mayor a 0.00"
                                    }
                                    ]
                                })(
                                    <Input
                                        addonAfter={<Icon type="tag" />}
                                        className="text-right"
                                        placeholder="Ingresar Línea de crédito"
                                        autoComplete="off"
                                        onKeyPress={global.onKeyPressDecimals}
                                        onBlur={(e) => {
                                            this.props.form.setFieldsValue({
                                                stockMin: global.onBlurDecimals(e, 2)
                                            });
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)